import React, { FC, useContext } from "react";
import { parseISO, format } from "date-fns";

import { Context } from "../../store/student";
import { replaceSearchTextAndUrl } from "../../libs/Convert";

import styles from "./RealizationPulseSurvey.module.scss";

type Props = {
  state: {
    searching: boolean;
    searchText: string;
  };
};

const RealizationPulseSurvey: FC<Props> = ({ state }) => {
  const { contextState } = useContext(Context);

  const renderContent = (content: string) => ({
    dangerouslySetInnerHTML: {
      __html: replaceSearchTextAndUrl(content, state.searchText ?? ""),
    },
  });

  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {contextState.pulse_survey_questions_with_answers.map(question => {
          return (
            <li key={question.id} className={styles.item}>
              <div className={styles.inner}>
                <p
                  className={styles.title}
                  {...renderContent(`Q. ${question.content}`)}
                />
                <p className={styles.score}>
                  スコア {question.answer.pulse_survey_question_score ?? `なし`}
                </p>
                <div className={styles.textBlock}>
                  {question.answer.pulse_survey_question_reason && (
                    <p
                      className={styles.text}
                      {...renderContent(
                        question.answer.pulse_survey_question_reason,
                      )}
                    />
                  )}
                  {question.answer.tomorrow_plan && (
                    <p
                      className={styles.text}
                      {...renderContent(question.answer.tomorrow_plan)}
                    />
                  )}
                </div>
                <p className={styles.date}>
                  {format(
                    parseISO(question.answer.created_at),
                    "yyyy/MM/dd HH:mm",
                  )}
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RealizationPulseSurvey;
